import variables from "../variables";
import images, { getRandomImage } from "../images";
import places from "../places/places";
import Man from "./Man";

const occupation = {
    id: "",
    caption: "",
    images: "",
    image: "",
    corruption: 0,
    where: "",
    getImage: function () {
        if (this.image === "") {
            if (variables.wife.occupation.picture === "")
                return alert("ERROR. No picture set for occupation in variables.");
            this.image = variables.wife.occupation.picture;
        }
        return this.image;
    },
    setImage: function (image="") {
        let img;
        if (image === "")
            img = getRandomImage(images.wife.occupations[this.images]);
        else
            img = images.wife.occupations[this.images][image];
        variables.wife.occupation.picture = img;
        this.image = img;
    }
};

const getOccupation = (id, i18n, where, corruption=0) => ({...occupation, id, caption: i18n, images: id, corruption, where});

const occupations = {
    sleep: getOccupation("sleep", "other.occupations.sleep", places.homeBedroom.id),
    wakeup: getOccupation("wakeup", "other.occupations.wakeup", places.homeBedroom.id),
    shower: getOccupation("shower", "other.occupations.shower", places.homeBathroom.id),
    breakfast: getOccupation("breakfast", "other.occupations.breakfast", places.homeKitchen.id),
    reading: getOccupation("reading", "other.occupations.reading", places.homeBedroom.id),
    lessons: getOccupation("lessons", "other.occupations.lessons", places.homeBedroom.id),
    cook: getOccupation("cook", "other.occupations.cook", places.homeKitchen.id),
    appearance: getOccupation("appearance", "", places.place.id),
    run: getOccupation("run", "other.occupations.run", places.homeMain.id),
    clean: getOccupation("clean", "other.occupations.clean", places.homeBedroom.id),
    clean2: getOccupation("clean2", "other.occupations.clean", places.homeKitchen.id),
    officeJob: getOccupation("officeJob", "other.occupations.officeJob", places.courierOffice.id)
};

occupations.set = function (occupationID="", image="") {
    if (!this[occupationID])
        occupationID = variables.wife.schedule[variables.game.time[1]][variables.game.time[0]]
    this.current = this[occupationID];
    wife.set("where", this.current.where);
    variables.wife.occupation.id = this.current.id;
    this.current.setImage(image);
};
occupations.setRandom = function (occIDsList=[]) {
    const occupationID = occIDsList[Math.floor(Math.random()*occIDsList.length)];
    this.set(occupationID)
};
occupations.get = function () {
    if (!this.current) {
        if (variables.wife.occupation.id === "")
            return alert("ERROR. 'variables.wife.occupation.id' is not defined");
        this.current = this[variables.wife.occupation.id];
    }
    return this.current;
};

const wife = new Man(
    "wife",
    variables.wife.name,
    "McNiel",
    "#e220d4",
    {
        nickname: variables.wife.nickname,
        age: 24,
        appearance: variables.wife.appearance,
        corruption: variables.wife.corruption,
        occupations,
        phone: variables.wife.phone,
        relations: variables.wife.relations,
        where: variables.wife.where
    }
);
wife.setNickname = function (nickname = "") {
    this.nickname = nickname;
    variables.wife.nickname = nickname;
};

export default wife;